export const COLORS = ['#4f46e5', '#f97316', '#14b8a6', '#ec4899', '#8b5cf6', '#06b6d4'];

export const LEAD_STATUS_COLORS: Record<string, string> = {
    new: '#6366f1',
    attempt_1_sent: '#f59e0b',
    attempt_2_sent: '#f97316',
    attempt_3_sent: '#ef4444',
    booked: '#10b981',
    canceled: '#94a3b8',
    inactive: '#64748b'
};

export const BOOKING_STATUS_COLORS: Record<string, string> = {
    confirmed: '#10b981',
    cancelled: '#ef4444',
    rescheduled: '#f59e0b'
};
